module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_6005.5a9ceb88.png";